import { render, staticRenderFns } from "./BulkMailDesign.vue?vue&type=template&id=78bcc4d6&"
import script from "./BulkMailDesign.vue?vue&type=script&lang=js&"
export * from "./BulkMailDesign.vue?vue&type=script&lang=js&"
import style0 from "./BulkMailDesign.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports